import { useContext } from "react";

import { TableContext } from "@sso/context/tableContext";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { Flex } from "@sso/ui/FlexBox";

import { TableSearchChip } from "../TableSearch/TableSearchChip";

export const TableHeaderFilters = () => {
  const dispatch = useAppDispatch();
  const { search } = useContext(TableContext);
  
  const handleClearSearchValue = (column: string) => {
    if (!search) {
      return;
    }
    dispatch(search.onClear(column));
  };

  if (!search) {
    return null;
  }
  return (
    <Flex wrap="wrap" width="100%" justify="flex-start">
      {Object.values(search.object).map(item => (
        <TableSearchChip
          key={item.column}
          title={item.title}
          onClearClick={() => handleClearSearchValue(item.column)}
        />
      ))}
    </Flex>
  );
};
